import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../services/translate.service';

@Pipe({
  name: 't',
  pure: false,
})
@Injectable({
  providedIn: 'root',
})
export class TranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(key: any): any {
    let upperKey = '';
    if (typeof key === 'string') {
      upperKey = key.toUpperCase();
    }
    if (this.translateService.data[key]) {
      return this.translateService.data[key];
    } else if (upperKey && this.translateService.data[upperKey]) {
      return this.translateService.data[upperKey];
    }
    return key;
  }

  transformWithInput(key: string, params?: { [key: string]: any }): string {
    let upperKey = key?.toUpperCase();
    let translation = this.translateService.data[key] || this.translateService.data[upperKey];

    if (!translation) return key;

    if (params) {
      Object.keys(params).forEach(param => {
        const value = params[param];
        const regex = new RegExp(`{{\\s*${param}\\s*}}`, 'g');
        translation = translation.replace(regex, value);
      });
    }

    return translation;
  }
}
